import React from 'react';
import './RelatedProducts.css';
import Item from '../Item/Item';
import all_product from '../all_product';

const RelatedProducts = ({ currentProductId, category }) => {
  // Filtra os produtos que pertencem à mesma categoria e que não sejam o produto atual
  const relatedItems = all_product
    .filter(item => item.category === category && item.id !== currentProductId)
    .slice(0, 4); // Seleciona os 4 primeiros itens relacionados

  return (
    <div className="relatedproducts">
      <h1>Produtos Relacionados</h1>
      <hr />
      <div className="relatedproducts-item">
        {relatedItems.length > 0 ? (
          relatedItems.map(item => (
            <Item
              key={item.id}
              id={item.id}
              name={item.name}
              // Usa a primeira imagem do array de imagens
              image={item.images && item.images[0]}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          ))
        ) : (
          <p>Nenhum produto relacionado encontrado.</p>
        )}
      </div>
    </div>
  );
};

export default RelatedProducts;
